import React from "react";
import { StoreAdminDetails } from "../../../types/modules/admin/StoreAdmin.type";
import CoverAndLogo from "./StoreAdminDetailsCard/CoverAndLogo";
import BasicInfo from "./StoreAdminDetailsCard/BasicInfo";
import StoreDetails from "./StoreAdminDetailsCard/StoreDetails";
import Sector from "./StoreAdminDetailsCard/Sector";
import Availability from "./StoreAdminDetailsCard/Availability";
import OpeningHours from "./StoreAdminDetailsCard/OpeningHours";
import StoreSections from "./StoreAdminDetailsCard/StoreSections";
import StoreOwner from "./StoreAdminDetailsCard/StoreOwner";

type Props = {
  store: StoreAdminDetails;
};

const StoreAdminDetailsCard: React.FC<Props> = ({ store }) => {
  
  return (
     <div className="space-y-8">
      <CoverAndLogo store={store} />

      <div className="pt-20 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-2xl shadow-custom-light p-6 space-y-6">
          <BasicInfo store={store} />
          <StoreDetails store={store} />
          <StoreOwner store={store}/>
          <Sector store={store} />
          <Availability store={store} />
        </div>

        <OpeningHours store={store} />
      </div>
      <div>
        <StoreSections storeId={store.id}/>
      </div>
    </div>
  );
};

export default StoreAdminDetailsCard;
